import styled from 'styled-components';
import { Typography } from '../../shared/typography';

interface IProp {
	isScrolled?: boolean;
}

const FixedTitle = styled.div`
	position: sticky;
	top: 0;
	z-index: 3;
	overflow: hidden;
`;

const Shadow = styled.div<IProp>`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	background-color: ${p => p.theme.colors.bgrdGrey};
	box-shadow: ${props =>
		props.isScrolled ? '0px 2px 20px rgba(33, 33, 30, 0.2)' : 'none'};
`;

const Title = styled(Typography)`
	font-size: 52px;
	line-height: 62px;
	font-weight: 600;
`;

const Search = styled.div`
	background-color: ${p => p.theme.colors.white};
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 68px;
	width: 100%;
	box-shadow: 0px 2px 2px rgba(33, 33, 30, 0.1);
	border-radius: 20px;
	margin-bottom: 16px;
	padding: 0 16px;
`;

const BtnAdd = styled.button`
	background-color: transparent;
	display: flex;
	align-items: flex-end;
`;

const Info = styled.div`
	border: 2px solid #2dc27e;
	border-radius: 82.4595px;
	padding: 6px 20px;
`;

const Content = styled.div<IProp>`
	margin: 25px 40px;
`;

const SearchWrapper = styled.div`
	display: flex;
	align-items: center;
	height: 50px;
	max-width: 600px;
	width: 100%;
	gap: 20px;
`;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
	FixedTitle,
	Shadow,
	Title,
	Search,
	BtnAdd,
	Info,
	Content,
	SearchWrapper,
};
